import { render, staticRenderFns } from "./FooterNuevo.vue?vue&type=template&id=53884f23&scoped=true"
import script from "./FooterNuevo.vue?vue&type=script&lang=js"
export * from "./FooterNuevo.vue?vue&type=script&lang=js"
import style0 from "./FooterNuevo.vue?vue&type=style&index=0&id=53884f23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53884f23",
  null
  
)

export default component.exports